import BaseController from '../BaseController';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { CheckInAliases, FragmentNames } from '../../codegen';
import {  QRCodeAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { PseudonymCustomMenssage } from '../pseudonym-appointments/pseudonym-interfaces';
import { CUSTOM_MESSAGE_ACTION } from '../pseudonym-appointments/pseudonym-types';
import './check-in-controller.css';
import UserContext from '../../utils/user-context';
import QRCode from '../../interfaces/qrcode';

@Controller({ fragment: FragmentNames.CHECK_IN })
class CheckInController extends BaseController {

  @Inject(CheckInAliases.TEXT_CHECK_IN_MESSAGE)
    fieldCheckInMessage!: TextAPI;

  @Inject(CheckInAliases.QR_CODE_CHECK_IN)
    qrCodeCheckIn!: QRCodeAPI;

  @OnMount({ target: CheckInAliases.PANEL_INTERNAL_CHECK_IN })
  onMountCheckIn(): void {
    HttpService.get(APPLICATION_ENDPOINTS.GET_WSUITE_CUSTOM_MESSAGE, { action: CUSTOM_MESSAGE_ACTION.CHECK_IN }).then(response => {
      const customMessage = response.body as PseudonymCustomMenssage;
      this.fieldCheckInMessage.setValue(customMessage?.message ?? MessageService.translate('patient.dashboard.check.in.message'));
    });

    HttpService.get(APPLICATION_ENDPOINTS.GET_ENCRYPTED_QRCODE, { patientId: UserContext.patientId }).then(response => {
      const qrcode = response.body as QRCode;
      this.qrCodeCheckIn.setValue(qrcode?.encryptedCode);
    });
  }

}

export default CheckInController;
